var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showGuide && _vm.show)?_c('div',{staticClass:"newer-guide"},[_c('img',{staticClass:"newer-guide__img",attrs:{"src":_vm.hasLogin ? require('../img/login-321c8.png') : require('../img/login-321c8.png'),"alt":"新手指南"}}),_vm._v(" "),_c('div',{staticClass:"newer-guide__close",on:{"click":_vm.closeGuide}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }